import React from "react";
import clsx from "clsx";
import "./Group.scss";
import { NodeContent, NodeInputProps } from "./common";
import { NodeHandles } from "./factory";

/**
 * A band.  Not built by `createShapeNode`: it has no shape, no fill gradient, and renders
 * `.group-heading` rather than `.node-content`.  The handles are the same eight every other node
 * exposes, so those do come from the factory.
 *
 * The heading's rule is drawn only under a heading that says something.  Whether it does cannot
 * be read from the props -- a consumer's `getNodeContent` may render an empty body for a group
 * with no label -- so the rendered text is checked after each commit.
 */
function Group(props: NodeInputProps) {
    const heading = React.useRef<HTMLDivElement>(null);
    const [empty, setEmpty] = React.useState(false);

    React.useLayoutEffect(() => {
        setEmpty(!(heading.current?.textContent ?? "").trim());
    }, [props.data]);

    return (
        <div className="FlowChart-node FlowChart-node-group">
            <NodeHandles />

            <div ref={heading} className={clsx("group-heading", empty && "group-heading--empty")}>
                <NodeContent {...props} />
            </div>
        </div>
    );
}

export { Group };
